import { AxiosPromise } from 'axios';
import request from '../network';

// EC兑换周更-上传 CSV 生成预览
export function uploadWeeklyCsv(formData: FormData): AxiosPromise<any> {
  return request({
    url: '/royalcanin/admin/operations/weekly-exchange/upload',
    method: 'POST',
    data: formData,
  });
}

// EC兑换周更-重新拉取预览
export function getPreview(batchNo: string): AxiosPromise<any> {
  return request({
    url: `/royalcanin/admin/operations/weekly-exchange/preview/${batchNo}`,
    method: 'GET',
  });
}

// EC兑换周更-执行批次
export function executeBatch(batchNo: string): AxiosPromise<any> {
  return request({
    url: `/royalcanin/admin/operations/weekly-exchange/execute/${batchNo}`,
    method: 'POST',
  });
}

// EC兑换周更-历史记录分页
export function getRunHistory(params: { pageNum?: number; pageSize?: number; status?: number }): AxiosPromise<any> {
  return request({
    url: '/royalcanin/admin/operations/weekly-exchange/history',
    method: 'GET',
    params,
  });
}

// EC兑换周更-运行详情
export function getRunDetail(runId: number | string): AxiosPromise<any> {
  return request({
    url: `/royalcanin/admin/operations/weekly-exchange/detail/${runId}`,
    method: 'GET',
  });
}

// EC兑换周更-导出核对结果 xlsx
export function exportRunResult(runId: number | string) {
  return import('../network').then(({ download }) =>
    download(`/royalcanin/admin/operations/weekly-exchange/export/${runId}`),
  );
}

// EC兑换周更-菜单可见性探测
export function getMenuVisible(): AxiosPromise<any> {
  return request({
    url: '/royalcanin/admin/operations/menu-visible',
    method: 'GET',
  });
}
